import { TransformEx } from "../../../LTGame/LTUtils/TransformEx";
import LTRes from "../../../LTGame/Res/LTRes";
import LayerDefine from "../../common/LayerDefine";
import ResDefine from "../../common/ResDefine";
import PlayerLogic from "../play/PlayerLogic";
import ItemBase from "./ItemBase";
import { ChallengeDoorConfig } from "../../config/ChallengeDoorConfig";
export default class ItemDoor_Level extends ItemBase {
    OnInit() {
        this.group = LayerDefine.Door;
        this.mask = LayerDefine.Root;
        let item = this.ownerTrans.owner;
        this.level = parseInt(item.getChildAt(0).name);
        this.CreateModel();
        this.CreateBody();
        this.CreateDoor();
    }
    CreateDoor() {
        return __awaiter(this, void 0, void 0, function* () {
            console.log(this.types);
            let id = this.types[1];
            let intro = yield LTRes.LoadAndGet(ResDefine.FixPath(ChallengeDoorConfig.data[id].model_path));
            this.rootObj.addChild(intro);
            TransformEx.ResetLocalTrans(intro.transform);
        });
    }
    BeginContact(other) {
        if (other instanceof PlayerLogic) {
            // let pos = other.GetRootPos();
            // let types: number[];
            // if (pos.x < this.rootObj.transform.position.x) {
            //     types = this.data[1];
            // } else {
            //     types = this.data[0];
            // }
            // let sign = types[1]
            // if (sign == 1 || sign == 3) {
            //     AudioManager.instance.PlayById(3);
            // } else {
            //     AudioManager.instance.PlayById(4);
            // }
            // other.ChangeAttributes(types[0], sign, types[2]);
            console.log("变更到对应等级" + this.level);
            other.UpdateIndexForce(this.level - 1);
        }
        this.Destroy();
    }
    OnUpdate(dt) {
        this.FromOwnerTrans();
    }
}
